import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

export const EngineSizeMin = withFacetContext(
    FacetName.engine_size,
    withFilterContext(FilterName.min_engine_size, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.engineSize.min,
    })
)

export const EngineSizeCCMin = withFacetContext(
    FacetName.engine_size_cc,
    withFilterContext(FilterName.min_engine_size_cc, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.engineSize.min,
    })
)

export const EngineSizeMax = withFacetContext(
    FacetName.engine_size,
    withFilterContext(FilterName.max_engine_size, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.engineSize.max,
    })
)

export const EngineSizeCCMax = withFacetContext(
    FacetName.engine_size_cc,
    withFilterContext(FilterName.max_engine_size_cc, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.engineSize.max,
    })
)
